import { render, staticRenderFns } from "./PPOBProduct.vue?vue&type=template&id=13dba3cf&scoped=true&"
import script from "./PPOBProduct.vue?vue&type=script&lang=js&"
export * from "./PPOBProduct.vue?vue&type=script&lang=js&"
import style0 from "./PPOBProduct.vue?vue&type=style&index=0&id=13dba3cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dba3cf",
  null
  
)

export default component.exports